import { useMemo } from 'react';

import useDailyRegistrations from '../../../../hooks/useDailyRegistrations';
import useProgramCompletion from '../../../../hooks/useProgramCompletion';

export type CtaVariant = 'welcome' | 'started' | 'finished';

const useBlockCta = () => {
  const {
    currentWeekNumber,
    registrationsToday,
  } = useDailyRegistrations();

  const { isProgramCompleted } = useProgramCompletion();

  const registrationGoal = registrationsToday?.goal;

  const variant: CtaVariant = useMemo(() => {
    if (isProgramCompleted) {
      return 'finished';
    }

    if (registrationsToday
      && (registrationGoal === undefined
      || registrationGoal === null)) {
      return 'welcome';
    }

    return 'started';
  }, [isProgramCompleted, registrationsToday, registrationGoal]);

  return {
    variant,
    currentWeekNumber,
    goalToday: registrationsToday ? registrationsToday.goal : null,
  };
};

export default useBlockCta;
